import React from 'react';

import MySixtyNavItems from './NavItems';

function MySixtyNav({ data, selected, setSelected }) {
    if (!data) {
        return null;
    }

    return (
        <div className="w-full flex flex-col md:flex-row items-start md:items-center justify-center md:justify-start ml-0 md:ml-4">
            {data.map((element) => (
                <MySixtyNavItems
                    key={element.value}
                    data={element}
                    selected={selected}
                    setSelected={setSelected}
                />
            ))}
        </div>
    );
}

export default MySixtyNav;
